import { render, staticRenderFns } from "./project_insurance.vue?vue&type=template&id=124cfbe6&"
import script from "./project_insurance.vue?vue&type=script&lang=js&"
export * from "./project_insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports